import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PlaygroundMap from "./PlaygroundMap";

// const allGrounds = [
//   { id: 1, name: "Football Ground A", sport: "Football", city: "Delhi", img: "/images/football.jpg" },
//   { id: 2, name: "Cricket Pitch B", sport: "Cricket", city: "Mumbai", img: "/images/cricket.jpg" },
//   { id: 3, name: "Badminton Court C", sport: "Badminton", city: "Delhi", img: "/images/badminton.jpg" },
//   { id: 4, name: "Football Ground D", sport: "Football", city: "Mumbai", img: "/images/football.jpg" },
// ];
const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const sportImages = {
  football: "https://img.icons8.com/color/96/football2.png",
  cricket: "https://img.icons8.com/color/96/cricket.png",
  badminton: "https://img.icons8.com/color/96/badminton.png",
  tennis: "https://img.icons8.com/color/96/tennis-ball.png",
};
const BookingPage = () => {
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [sports, setSports] = useState([]);
  const [playgrounds, setPlaygrounds] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedSport, setSelectedSport] = useState("");
  const [error, setError] = useState("");
  const [availableSlots, setAvailableSlots] = useState({}); // per ground
  const [bookingData, setBookingData] = useState({});
  const [bookingId, setBookingId] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [showCancelSection, setShowCancelSection] = useState(false);

    React.useEffect(() => {
  
      const fetchPlayGrounds = async () => {
        try {
          const res = await fetch(`${apiUrl}/playgrounds`, {
            headers: {
                'API_KEY': `${apiKey}`
              }
          });
          const data = await res.json();
          setCities(data.cities || []);
        setSports(data.sports || []);
        setPlaygrounds(data.playgrounds || []);
        } catch (err) {
          console.error('Failed to load playgrounds:', err);
        }
      };
      fetchPlayGrounds();
    }, []);

    const handleCancel = async (bookingId) => {
      setMessage("")
      if (!bookingId) {
        setMessage("⚠️ Please enter a Booking ID.");
        return;
      }
      try {
        const res = await fetch(`${apiUrl}/playground/booking`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "API_KEY": apiKey,
          },
          body: JSON.stringify({ bookingId }),
        });
    
        if (!res.ok) {
          setBookingId("");
          const errorData = await res.text();
          setMessage(`❌ Failed to cancel booking`);
          return;
        } 
        // Clear booking state if you have it
        setBookingData((prev) => ({
          ...prev,
          [bookingId]: { date: "", slot: "" },
        }));
    
        setMessage(`✅ Booking ${bookingId} cancelled successfully.`);
        setBookingId(""); // clear input
      } catch (err) {
        setBookingId("");
        console.error(err);
        setMessage("❌ An error occurred while cancelling the booking.");
      }
    };
  const handleDateChange = (groundId, date) => {
   
  // Update booking date for this playground
  setBookingData(prev => ({
    ...prev,
    [groundId]: {
      ...prev[groundId],
      bookingDate: date,
      slot: "" // reset slot when date changes
    }
  }));
  

    fetchSlots(groundId, date); // ⬅️ call happens here
  };

  const handleReserve =  async (pg, groundId) => {
    const booking = bookingData[groundId];
    setError("")
    if (!booking?.bookingDate || !booking?.slot) {
      setError("Please select a date and time slot before reserving.")
      return;
    }
  
    // Example payload for backend
    const payload = {
      groundId,
      groundName: pg.name,
      sport: pg.sport,
      city: pg.city,
      bookingDate: booking.bookingDate,
      slot: booking.slot,
    };
  
    console.log("Reserving:", payload);
  
    // 👉 Call API here
    const res = await fetch(`${apiUrl}/playground/booking`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'API_KEY': `${apiKey}`},
      body: JSON.stringify(payload)
    });
    if (res.ok) {
      const savedBooking = await res.json(); // includes bookingId from backend
      setBookingData((prev) => {
        const updated = { ...prev };
        delete updated[groundId]; // remove only this ground's booking
        return updated;
      });

      setAvailableSlots((prev) => {
        const updated = { ...prev };
        updated[groundId] = []; // clear slots for this ground
        return updated;
      });

      //navigate("/booking-confirmation", { state: { booking: savedBooking } });
      navigate("/upi-payment-link", { state: { booking: savedBooking } });
       }
       
       else{
        const errorMessage = await res.text(); // read message from Go's http.Error
        setError(errorMessage);
        return;
      }
  };

  // Filter grounds based on selected city and sport
  const filteredGrounds = playgrounds.filter(
    (ground) =>
      (selectedCity === "" || ground.city === selectedCity) &&
      (selectedSport === "" || ground.sport === selectedSport)
  );

  const handleTimeChange = (groundId, slot) => {
    setBookingData(prev => ({
      ...prev,
      [groundId]: {
        ...prev[groundId],
        slot
      }
    }));
  };

  // fetch slots for a ground when date is chosen
const fetchSlots = async (groundId, date) => {
    try {
      const res = await fetch(`${apiUrl}/playground/${groundId}/${date}/slot`, {
        headers: {
          'API_KEY': `${apiKey}`,
        },
      });
      const data = await res.json();
   
    setAvailableSlots(prev => ({
      ...prev,
      [groundId]: Array.isArray(data) ? data : []
    }));
    } catch (err) {
      console.error("Error fetching slots:", err);
      setAvailableSlots(prev => ({ ...prev, [groundId]: [] }));
    }
  };


  return (
    
<div className="min-h-screen bg-blue-100 px-5 pt-24">  {/* 👈 Added pt-24 */}
<header className="fixed top-0 left-0 w-full z-50 text-sm text-white py-4 sm:py-6 bg-blue-900 shadow-md">
  <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-0">
    
    {/* 🔹 Left: Logo + Tagline */}
    <div className="flex flex-col items-center sm:items-start">
      <div className="flex items-center gap-2">
        <img
          src="/image1.png"
          alt="Logo"
          className="h-12 w-12 sm:h-16 sm:w-16 rounded-full shadow"
        />
        <h1 className="text-xl sm:text-2xl font-bold italic whitespace-nowrap">
          <span className="text-white">League</span>
          <span className="text-red-500">Sphere</span>
        </h1>
      </div>
      <span className="text-purple-200 italic text-xs sm:text-sm">
        Plan. Promote. Play
      </span>
    </div>
    </div>
</header>
<br></br>
<br></br>
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 mb-6 text-center">🎯 Book Your Slot</h1>
        <p className="text-center text-gray-600 mb-8 italic">
          Select your city and sport to see available grounds.
        </p>

        {/* Filters */}
        <div className="flex flex-col md:flex-row gap-4 mb-12 justify-center">
          <select
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            className="w-80 px-4 py-3 rounded-2xl border border-gray-200 shadow-sm bg-white
               focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
               transition duration-200"
          >
           <option value="">Select City</option>
           {cities.map(city => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
          </select>

          <select
            value={selectedSport}
            onChange={(e) => setSelectedSport(e.target.value)}
            className="w-80 px-4 py-3 rounded-2xl border border-gray-200 shadow-sm bg-white
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
            transition duration-200"         >
            <option value="">Select Sport</option>
            {sports.map(sport => (
            <option key={sport} value={sport}>
              {sport}
            </option>
          ))}
          </select>

        </div>

        {error && <p className="text-red-600 font-medium">{error}</p>}


        {/* Playground Cards */}
        <div className="grid gap-8 md:grid-cols-3">
  {filteredGrounds.length > 0 ? (
    filteredGrounds.map((pg) => (
      <div
        key={pg.groundId}
        className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300"
      >
      <img
  src={sportImages[pg.sport.toLowerCase()] || "https://img.icons8.com/color/96/sports.png"} 
  alt={pg.sport}
  className="w-12 h-12 object-contain rounded-xl shadow-md bg-white p-2"
/>
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-800">{pg.name}</h2>
          <p className="text-gray-500 mb-2">Sport: {pg.sport}</p>
          <p className="text-gray-500 mb-4">City: {pg.city}</p>

          {/* Date & Time Pickers */}
          <div className="flex flex-col gap-4">
          <input
  type="date"
  value={bookingData[pg.groundId]?.bookingDate || ""}
  onChange={(e) => handleDateChange(pg.groundId, e.target.value)}
  min={new Date().toISOString().split("T")[0]}
  className="px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
/>

<select
  value={bookingData[pg.groundId]?.slot || ""}
  onChange={(e) => handleTimeChange(pg.groundId, e.target.value)}
  className="px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
  disabled={!availableSlots[pg.groundId] || availableSlots[pg.groundId].length === 0}
>
  <option value="">Select a time slot</option>
  {(availableSlots[pg.groundId] || []).map((slot, i) => (
    <option key={i} value={slot}>
      {slot}
    </option>
  ))}
</select>

            {/* Reserve & Cancel Buttons */}
            <div className="flex gap-4 mt-2">
            <button
    onClick={() => handleReserve(pg, pg.groundId)}
    className="flex-1 px-4 py-3 bg-blue-600 text-white font-semibold rounded-xl shadow hover:bg-blue-700 transition-transform transform hover:scale-105"
  >
    Reserve Now
  </button>


            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <p className="text-center col-span-full text-gray-500">
      No grounds available currently.
      <p className="mt-3 text-gray-700">
 We’re teaming up with{" "}
 <span className="font-semibold text-yellow-700">Playground Owners & Academies</span>{" "}
to bring you a smooth booking experience for all your favorite sports.
</p>
    </p>

  )}
</div>
      </div>
       {/* Floating Cancel Button */}


       <div className="min-h-screen flex flex-col items-center p-6">
  {/* Main Cancel Button */}
  <button
    onClick={() => setShowCancelSection(!showCancelSection)}
    className="px-6 py-3 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition mb-4"
  >
    🔴 Cancel Booking
  </button>

  {/* Collapsible Cancel Section */}
  {showCancelSection && (
   <div className="flex flex-col items-center gap-3 w-full sm:w-80 p-6 bg-white border border-gray-200 rounded-xl shadow-lg">
   
   {/* Booking ID input */}
   <input
     type="text"
     placeholder="Enter Booking ID"
     value={bookingId}
     onChange={(e) => setBookingId(e.target.value)}
     className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-400"
   />
 
   {/* Confirm Cancel button */}
   <button
     onClick={() => handleCancel(bookingId)} // Pass bookingId here!
     className="w-full px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition"
   >
     Confirm Cancel
   </button>
 
   {message && <p className="mt-2 text-sm text-gray-700 text-center">{message}</p>}
 </div>
  )}
</div>


    </div>
    
  );

// return (
// <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-white-50 via-white-100 to-white-200 px-6 py-12 space-y-12">
  
//   {/* <div className="w-full max-w-lg bg-white rounded-3xl shadow-2xl p-6 space-y-6 border border-blue-100 transform transition hover:scale-[1.03] hover:shadow-blue-200">
//     <h1 className="text-2xl font-bold text-black-700 italic tracking-wide text-center drop-shadow">
//       🏟️ Discover Nearby Playgrounds & Academies
//     </h1>
 
// <div className="w-full max-w-md sm:max-w-2xl lg:max-w-5xl rounded-2xl overflow-hidden border border-gray-200 shadow-md mx-auto">
//   <div className="h-[200px] sm:h-[240px] lg:h-[260px]">
//     <PlaygroundMap />
//   </div>
// </div>
//     <p className="text-center text-gray-600 text-sm italic">
//       🌍 Explore sports facilities around you — football, cricket, tennis & more.
//     </p>
//   </div> */}

//   <div className="relative w-full max-w-lg bg-gradient-to-r from-yellow-50 via-yellow-100 to-yellow-50 rounded-3xl shadow-2xl p-8 overflow-hidden transform transition hover:scale-[1.02] hover:shadow-yellow-200">
//     <div className="absolute -top-30 -right-10 text-yellow-200 text-7xl opacity-20">⚡</div>
//     <div className="flex items-start space-x-4">
//       <span className="text-4xl animate-bounce text-yellow-500">⚡</span>
//       <div>
//         <h2 className="text-2xl font-bold leading-snug text-gray-900">
//           Playground Booking <span className="text-yellow-600">Coming Soon!</span>
//         </h2>
//         <p className="mt-3 text-gray-700">
//           We’re teaming up with{" "}
//           <span className="font-semibold text-yellow-700">Playground Owners & Academies</span>{" "}
//           to bring you a smooth booking experience for all your favorite sports.
//         </p>
//       </div>
//     </div>
//     <p className="mt-6 text-center text-gray-600 italic">
//       🌟 Exciting features are on the way — stay tuned!
//     </p>

//     {/* Optional CTA */}
//     <div className="flex justify-center mt-6">
//       <button className="px-6 py-2 bg-yellow-500 text-white font-semibold rounded-xl shadow-md hover:bg-yellow-600 hover:shadow-lg transition">
//         🔔 Notify Me
//       </button>
//     </div>
//   </div>
// </div>

// );
};




export default BookingPage;